var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashoutIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 586.7",
    style: {
      enableBackground: "new 0 0 640 586.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE0E54;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.7,186.7c48,0,88,34.7,93.3,80s-34.7,80-90.7,80s-96-34.7-93.3-80S274.7,186.7,322.7,186.7z M445.3,133.3 l50.7,296c-8-2.7-16-2.7-29.3-2.7c-40,2.7-72,29.3-74.7,58.7c0,8,0,16,2.7,21.3h-128c2.7-5.3,2.7-13.3,2.7-21.3 c-5.3-29.3-37.3-56-77.3-58.7c-10.7,0-21.3,0-29.3,0L200,133.3h-66.7L64,506.7c-8,45.3,0,80,66.7,80H536c66.7,0,72-34.7,61.3-80 l-90.7-373.3h-61.3V133.3z M613.3,0H26.7C10.7,0,0,10.7,0,26.7V160c0,16,10.7,26.7,26.7,26.7h40L90.7,80h456l32,106.7h34.7 c16,0,26.7-10.7,26.7-26.7V26.7C640,10.7,629.3,0,613.3,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashoutIconRed);
export default __webpack_public_path__ + "static/media/cashout_icon-red.ea2523b73b932939206de53a1306f0a3.svg";
export { ForwardRef as ReactComponent };